module.exports = __webpack_public_path__ + "images/pages/lp/comment_balloon_7_b181798b438d10c5e93437bd697dea88.png";